import { Category } from '@synergy/models';
import { createSelector } from 'reselect';

import { AppState } from '../../store/models/app-state';

const categoriesState = (state: AppState) => state.categories;

export const currentlyLoadedCategoriesSelector = createSelector([categoriesState], categories =>
    Object.values(categories.categoriesByParentId).flat()
);

export const categoriesByParentIdSelector = createSelector(
    [(state: AppState) => state.categories.categoriesByParentId, (state, parentId?: number) => parentId],
    (categoriesByParentId, parentId?: number): Category[] | null => categoriesByParentId[parentId ?? -1] ?? null
);
